import React from 'react';

import PostSignatureRequestCard from '~/components/Documents/ESign/PostSignatureRequestCard';
import PreSignatureRequestCard from '~/components/Documents/ESign/PreSignatureRequestCard';
import type { DocumentMetaData } from '~/server_shared/swagger/data-contracts';

import type { SignatureRequestData } from './utils';

interface Props {
  document: DocumentMetaData;
  onCancel: () => void;
  onSuccess: (signUrl: string) => void;
}

const NewSignatureRequestCard: React.FC<Props> = ({ document, onCancel, onSuccess }) => {
  const [signatureRequestData, setSignatureRequestData] = React.useState<SignatureRequestData | null>(null);

  if (signatureRequestData) {
    return (
      <PostSignatureRequestCard
        contact={signatureRequestData.contact}
        signUrl={signatureRequestData.signUrl}
        claimId={signatureRequestData.claimId}
        onClose={() => {
          onSuccess(signatureRequestData.signUrl);
          onCancel();
        }}
      />
    );
  }

  return (
    <PreSignatureRequestCard
      document={document}
      onCancel={onCancel}
      onSuccess={(data) => {
        setSignatureRequestData(data);
      }}
    />
  );
};

export default NewSignatureRequestCard;
